import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c501ff7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-flex-direction-column" }
const _hoisted_2 = { class: "columns is-vcentered" }
const _hoisted_3 = { class: "column is-8" }
const _hoisted_4 = {
  id: "page-title",
  class: "title is-4 is-uppercase has-text-weight-medium is-inline"
}
const _hoisted_5 = {
  id: "litigations-count",
  class: "subtitle is-5 is-italic"
}
const _hoisted_6 = { class: "column is-4" }
const _hoisted_7 = { class: "new-litigation-buttons" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "users" }
const _hoisted_10 = { class: "description" }

import { Plus } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import { computed, Ref, ref } from 'vue';
import { useRouter } from 'vue-router';

import LitigationMembersList from '@/components/LitigationMembersList.vue';
import { canCreateLitigation } from '@/helpers/permission';
import { Litigation } from '@/Litigation/litigation.entity';
import LitigationService from '@/Litigation/litigation.service';
import { Member } from '@/Member/member.entity';

export default /*#__PURE__*/_defineComponent({
  __name: 'LitigationList',
  setup(__props) {

const litigations: Ref<Litigation[] | null> = ref(null);
const newLitigationName: Ref<string> = ref('');
const newLitigationNameInput: Ref<HTMLElement | null> = ref(null);
const createLitigationPopoverVisible: Ref<boolean> = ref(false);

const router = useRouter();

const chunkedLitigations = computed((): Litigation[][] | null => {
    const size = 4;

    if (litigations.value === null) {
        return null;
    }

    const chunks = [];
    const litigationsCopy = [...litigations.value];
    while (litigationsCopy.length) {
        chunks.push(litigationsCopy.splice(0, size));
    }

    return chunks;
});

const openCreateLitigationPopover = () => {
    createLitigationPopoverVisible.value = true;
    setTimeout(() => {
        const input = newLitigationNameInput.value;
        if (input) {
            input.focus();
        }
    }, 0);
};

const litigationMembers = (litigation: Litigation): Member[] => {
    return (litigation.members ?? []).filter((member) => member.isEnabled);
};

const populateLitigations = async (): Promise<void> => {
    const litigationService = new LitigationService();
    try {
        litigations.value = await litigationService.findAll();
    } catch (error) {
        const { message } = error as { message: string };
        ElMessage.error(message);
    }
};

const createLitigation = async (): Promise<void> => {
    const litigationService = new LitigationService();
    try {
        const litigation = await litigationService.create(newLitigationName.value);
        litigations.value = litigations.value || [];
        litigations.value.push(litigation);
        if (litigation.litigationId) {
            router.push({ name: 'litigation-form', params: { litigationId: litigation.litigationId } });
        }
    } catch (error) {
        const { message } = error as { message: string };
        ElMessage.error(message);
    }
};

populateLitigations();

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (litigations.value != null)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('listLitigations.litigations')), 1),
                _createElementVNode("span", _hoisted_5, " (" + _toDisplayString(litigations.value.length) + ")", 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_unref(canCreateLitigation)())
                  ? (_openBlock(), _createBlock(_component_el_popover, {
                      key: 0,
                      visible: createLitigationPopoverVisible.value,
                      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((createLitigationPopoverVisible).value = $event)),
                      placement: "bottom",
                      width: 250
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          icon: _unref(Plus),
                          class: "button is-primary is-radius-small has-text-weight-semibold is-pulled-right",
                          onClick: openCreateLitigationPopover
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('listLitigations.addLitigation')), 1)
                          ]),
                          _: 1
                        }, 8, ["icon"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          ref_key: "newLitigationNameInput",
                          ref: newLitigationNameInput,
                          modelValue: newLitigationName.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newLitigationName).value = $event)),
                          placeholder: "Code..."
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_el_button, {
                            size: "small",
                            class: "button is-radius-small has-text-weight-semibold",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (createLitigationPopoverVisible.value = false))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('listLitigations.cancel')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            disabled: '' === newLitigationName.value,
                            size: "small",
                            class: "button is-primary is-radius-small has-text-weight-semibold",
                            onClick: createLitigation
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('listLitigations.create')), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["visible"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (chunkedLitigations.value && chunkedLitigations.value.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(chunkedLitigations.value, (_, index) => {
                  return (_openBlock(), _createBlock(_component_el_row, {
                    key: index,
                    gutter: 10,
                    justify: "start"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunkedLitigations.value[index], (litigation) => {
                        return (_openBlock(), _createBlock(_component_el_col, {
                          key: litigation.litigationId,
                          span: 6,
                          class: "litigation-card"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_card, {
                              "body-style": { cursor: 'pointer' },
                              shadow: "hover",
                              onClick: ($event: any) => (
                                    _unref(router).push({
                                        name: 'analysis-list',
                                        params: { litigationId: litigation.litigationId },
                                    })
                                )
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_8, _toDisplayString(litigation.name.toUpperCase()), 1),
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(LitigationMembersList, {
                                    members: litigationMembers(litigation),
                                    "litigation-name": litigation.name
                                  }, null, 8, ["members", "litigation-name"])
                                ]),
                                _createElementVNode("p", _hoisted_10, _toDisplayString(litigation.description || '...'), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              : (_openBlock(), _createBlock(_component_el_empty, { key: 1 }))
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})